<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_PAYMENTS.ADD_RESELLER_PAYMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <resellerPayment-form
              :loading="loading"
              :resellerPaymentData="resellerPayment"
              :formErrors="formErrors"
              @resellerPaymentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerPayment from "./defaultResellerPayment";
import ResellerPaymentForm from "./partials/ResellerPaymentForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ResellerPaymentForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      resellerPayment: cloneDeep(defaultResellerPayment),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List ResellerPayments" });
    },

    viewResellerPayment(resellerPayment) {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerPayment",
        params: { id: resellerPayment.id },
      });
    },

    async handleSubmit(resellerPaymentData) {
      this.loading = true;
      try {
        await this.$store.dispatch("resellerPayments/add", resellerPaymentData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_PAYMENTS.RESELLER_PAYMENT_ADDED"),
        });
        const resellerPayment = await this.$store.getters[
          "resellerPayments/resellerPayment"
        ];
        this.viewResellerPayment(resellerPayment);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
